import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'messageArgs'
})
export class MessageArgumentsPipe implements PipeTransform {
  /* @args is linked to app/api/interfaces/Messages/IMessage#params otherwise adapt it for more generic. */
  transform(message: string, args: string[]): string {
    if (args && args.length > 0) {
      for (let i = 0; i < args.length; i++) {
        message = message.replace(`{${i}}`, args[i]);
      }
    }
    return message;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/pipe/message-arguments.pipe.ts